import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import './lib/theme';
import './lib/i18n';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
